// System
import { useSnackbar } from 'notistack';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { setShowUserDrawer, setSelectedUser } from '@Modal/reducers/users/drawer/userDrawerSlice';
// Types
import { AppDispatch } from 'src/app/store';
import { StoreInterface } from 'src/app/types';
import { useGetUserLazyQuery } from '@Src/generated.graphql';

export const useUserDrawer = () => {
  const [getUser] = useGetUserLazyQuery();

  // Redux
  const dispatch = useDispatch<AppDispatch>();
  const { selectedUser, showUserDrawer } = useSelector(
    (state: StoreInterface) => state?.userDrawer
  );

  // Other Hooks
  const { enqueueSnackbar } = useSnackbar();

  const handleUserRowClick = async (id: string) => {
    try {
      const { data } = await getUser({ variables: { id: id } });
      if (data && data.user) {
        await dispatch(setSelectedUser(data.user));
      }
      dispatch(setShowUserDrawer(true));
    } catch (error) {
      enqueueSnackbar(error, {
        autoHideDuration: 2000,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    }
  };

  return {
    // Store
    selectedUser,
    showUserDrawer,
    // Actions
    setSelectedUser,
    setShowUserDrawer,
    // Handlers
    handleUserRowClick,
  };
};
